<template>
    <v-dialog
        v-if="isVisible"
        v-model="isVisible"
        transition="dialog-top-transition"
        scrollable
        persistent
        max-width="700"
    >
        <v-card class="modal-maincard">

            <v-toolbar dark flat dense>
                <v-toolbar-title>{{ $t(title) }}</v-toolbar-title>
            </v-toolbar>

            <v-card-text
                class="wrapperFormModal"
            >
                <v-card flat>
                    <v-card-text>
                        
                        <v-form ref="form" lazy-validation>

                            <v-row no-gutters>

                                <v-col cols="12" sm="12" md="3">
                                    <label class="f-label">{{$t("Вид_обследования")}}</label>
                                </v-col>

                                <v-col cols="12" sm="12" md="9">
                                    <v-select
                                        return-object
                                        v-model="typeOfExamination"
                                        :items="getTypesOfExamination"
                                        :item-text="item => $refLocale(item, $i18n.locale)"
                                        hide-details
                                        required
                                        outlined
                                        dense
                                        append-icon="fas fa-chevron-down"
                                        :menu-props="{ bottom: true, offsetY: true }"
                                    >
                                    </v-select>
                                </v-col>

                            </v-row>

                            <v-row no-gutters>
                                <v-col cols="12" sm="12" md="3">
                                    <label class="f-label">{{$t("Адрес_организации")}}</label>
                                </v-col>
                                <v-col cols="12" sm="12" md="9">
                                    <v-textarea 
                                        v-model="address"
                                        rows="3"
                                        no-resize
                                        hide-details
                                        required
                                        outlined
                                        dense
                                        :rules="requiredRule"
                                    />
                                </v-col>
                            </v-row>

                            <v-row no-gutters>
                                <v-col cols="12" sm="12" md="3">
                                    <label class="f-label">{{$t("Телефон_организации")}}</label>
                                </v-col>
                                <v-col cols="12" sm="12" md="9">
                                    <v-textarea 
                                        v-model="phone"
                                        rows="3"
                                        no-resize
                                        hide-details
                                        required
                                        outlined
                                        dense
                                        :rules="requiredRule"
                                    />
                                </v-col>
                            </v-row>


                        </v-form>

                    </v-card-text>
                </v-card>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn 
                    color="cyan"
                    text
                    depressed
                    @click="ok"
                    v-if="isValid"
                >
                    {{ $t("Сформировать_и_отправить") }} 
                </v-btn>

                <v-btn
                    color="blue-grey"
                    text
                    depressed
                    @click="cancel"
                >
                    {{ $t("Отмена") }}
                </v-btn>

            </v-card-actions>

        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    name: "CSCConfirmReceptionDlg",
    data () {
        return {
            title: "Сформировать_уведомление_и_отправить_заявителю",
        }
    },
    computed: {
        ...mapGetters('global/actionsource', { getDataSource: 'getDataSource'}),
        ...mapGetters('qalaQyzmet/dialogs/cscConfirmReception', ['isVisible', 'isValid', 'getTypesOfExamination']),
        ...mapGetters({ requiredRule: 'getRequiredRule',}),

        typeOfExamination: {
            get: function() {
                return this.$store.getters['qalaQyzmet/dialogs/cscConfirmReception/getTypeOfExamination'];
            },
            set: function(v) {
                this.$store.commit('qalaQyzmet/dialogs/cscConfirmReception/SET_TYPEOFEXAMINATION', v); 
                this.validateFormMethod();
            }
        },
        address: {
            get: function() {
                return this.$store.getters['qalaQyzmet/dialogs/cscConfirmReception/getAddress'];
            },
            set: function(v) {
                this.$store.commit('qalaQyzmet/dialogs/cscConfirmReception/SET_ADDRESS', v); 
                this.validateFormMethod();
            }
        },
        phone: {
            get: function() {
                return this.$store.getters['qalaQyzmet/dialogs/cscConfirmReception/getPhone'];
            },
            set: function(v) {
                this.$store.commit('qalaQyzmet/dialogs/cscConfirmReception/SET_PHONE', v); 
                this.validateFormMethod();
            }
        }
    },
    methods: {
        ...mapActions('qalaQyzmet/dialogs/cscConfirmReception', ['ok', 'cancel']),
        validateFormMethod(){
            this.$refs?.form?.validate();    
        }
    }
}
</script>